"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PRODUCT_WITH_SHADES_FRAGMENT = exports.BASE_PRODUCT_FRAGMENT = void 0;
var _fetching = require("@ori/fetching");
var _concept = require("./concept");
const BASE_PRODUCT_FRAGMENT = exports.BASE_PRODUCT_FRAGMENT = (0, _fetching.gql)`
  ${_concept.BASE_CONCEPT_FRAGMENT}
  fragment BaseProduct on Product {
    backInStockAvailability {
      showBackInStockNotification
    }
    concept {
      ...BaseConcept
    }
    formattedPrice {
      price {
        basicCataloguePrice
        currentPrice
        previousMinOfferPrice
        priceAfterImmediateDiscount
      }
    }
    labels {
      ...ProductLabels
    }
    price {
      price {
        basicCataloguePrice
        currentPrice
        previousMinOfferPrice
        priceAfterImmediateDiscount
      }
    }
    imageUrl
    externalPicking
    isOffStock
    mainImage {
      url
      altText
    }
    productCode
    replacedByProduct {
      productCode
    }
    replacementForProduct {
      productCode
    }
    subscription {
      available
    }
  }
`;
const PRODUCT_WITH_SHADES_FRAGMENT = exports.PRODUCT_WITH_SHADES_FRAGMENT = (0, _fetching.gql)`
  ${BASE_PRODUCT_FRAGMENT}
  fragment ProductWithShades on Product {
    ...BaseProduct
    concept {
      ...BaseConcept
      products {
        shadeName
        hexColors
        colorImageUrl
        productCode
      }
    }
  }
`;
//# sourceMappingURL=product.js.map